export default {
  en: {
    ClientIndex: {
      title: 'Clients',
    },
  },
};
